
  <form class="row m-t-34 m-t-xs-40 m-b-29 form-width-size form-general-styles first-container-identification-xs" [formGroup]="form" (ngSubmit)="saveStepOne($event)" autocomplete="off"> 
      
    <div class="col-12 m-b-36 d-flex justify-content-between align-items-start">
      <div class="container-return-style align-self-start">
        <img class="img-return-blue" [src]="url_img.return_blue" alt="" (click)="previous()">
      </div>
      <div class="content__logo__xs">
        <img class="logo-img-size logo__astronaut" [src]="url_img.logo_blue" alt="">	
      </div>
      <app-header-steps></app-header-steps>
    </div>
    <div class="col-12 m-b-20">
      <div class="">
        <div class="d-block w-100">
          <p class=" heading-b-b-26 text-start line-height-33 text-start m-b-24 m-b-sm-16">
            Sueña en grande, invierte como experto
          </p>
          <p class="paragraph-b-r-16 line-height-1-19 m-b-12">
            Recuerda tener a la mano tu INE o pasaporte vigente y un comprobante de domicilio no mayor a 3 meses. Para abrir tu cuenta deberás contar con la mayoría de edad.
          </p>
        </div>
      </div>
    </div>
    
     
     <div class="col-12 m-b-20 ">
       <div [ngClass]="{'input-error-style': nameInput.invalid && nameInput.touched && nameInput.dirty }">
         <label for="" class="paragraph-b-r-16 mb-2">
           Nombre(s)
         </label>
         <input class="form-control input-field-style" 
                 placeholder="Como aparece en tu identificación oficial" 
                 type="text"
                 oninput="this.value = this.value.toUpperCase()"
                 only-letters
                 maxlength="50"
                 autocomplete="off"
                 formControlName="cx_nombre"
                 required>
         <p class="text-error-style d-flex align-items-center" *ngIf="nameInput.invalid && nameInput.touched && nameInput.dirty">
           <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
         </p>
       </div>
     </div>
     <div class="col-6 m-b-20">
       <div [ngClass]="{'input-error-style': surnamePInput.invalid && surnamePInput.touched && surnamePInput.dirty }">
         <label for="" class="paragraph-b-r-16 mb-2">
           Apellido paterno
         </label>
         <input  class="form-control input-field-style" 
                 placeholder="" 
                 type="text"
                 oninput="this.value = this.value.toUpperCase()"
                 only-letters
                 maxlength="50"
                 autocomplete="off"
                 formControlName="cx_apellido_p"
                 required>
         <p class="text-error-style d-flex align-items-center" *ngIf="surnamePInput.invalid && surnamePInput.touched && surnamePInput.dirty">
           <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
         </p>
       </div>
     </div>
     <div class="col-6 m-b-20">
       <div [ngClass]="{'input-error-style': surnameMInput.invalid && surnameMInput.touched && surnameMInput.dirty }">
         <label for="" class="paragraph-b-r-16 mb-2">
           Apellido materno
         </label>
         <input  class="form-control input-field-style" 
                 placeholder="" 
                 type="text"
                 oninput="this.value = this.value.toUpperCase()"
                 only-letters
                 maxlength="50"
                 autocomplete="off"
                 formControlName="cx_apellido_m"
                 required>
         <p class="text-error-style d-flex align-items-center" *ngIf="surnameMInput.invalid && surnameMInput.touched && surnameMInput.dirty">
           <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
         </p>
       </div>
     </div>
     <div class="col-12 m-b-20">
       <div [ngClass]="{'input-error-style': showErrorEmail() }">
         <label for="" class="paragraph-b-r-16 mb-2">
           Correo electrónico
         </label>
         <input  class="form-control input-field-style" 
                 placeholder="" 
                 type="text"
                 oninput="this.value = this.value.toUpperCase()"
                 only-email
                 maxlength="200"
                 autocomplete="off"
                 formControlName="cx_correo"
                 required>
         <p class="text-error-style d-flex align-items-center" *ngIf="showErrorEmail()">
           <img class="circle-error-tomato" [src]="url_img.alert" alt=""> {{msgErrorEmail}}
         </p>
       </div>
     </div>
     <div class="col-12 m-b-20">
       <div class="input-error-style" [ngClass]="{'input-error-style': showErrorPhone() }">
         <label for="" class="paragraph-b-r-16 mb-2">
           Celular a 10 dígitos
         </label>
         <div ngbDropdown class="button-dropdown-style d-block w-100">
           <div class="d-flex">
           <div class="button-generic-style button-outline button-drop-style drop-custom-flag text-start width-75 height-48 d-flex justify-content-around align-items-center" id="dropdownBasic1" ngbDropdownToggle>
             <img class="img-country-size" [src]="selectedImgContry" alt="">
             <img class="img-down-blue" [src]="url_img.down_blue" alt=""> 
           </div>
           <input  class="form-control input-field-style input-country-style d-inline-block"
                   placeholder="" 
                   type="text"
                   only-number
                   maxlength="10"
                   autocomplete="off"
                   formControlName="int_telefono"
                   required>
           <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">
             <div ngbDropdownItem *ngFor="let country of countriesSelect" (click)="setCountry(country.land1)">
               <img class="img-country-size m-r-6" [src]="url_img.countries+country.land1+'.svg' | lowercase" alt="" > <span class="first-letter-capitalize">{{country.landx}}</span>
             </div>
           </div>
         </div>        
           <p class="text-error-style d-flex align-items-center" *ngIf="showErrorPhone()">
             <img class="circle-error-tomato" [src]="url_img.alert" alt=""> {{msgErrorPhone}}
           </p>
         </div>
       </div>
     </div>
   
     <div class="col-12 m-b-20">
       <p class=" paragraph-b-r-16 text-start line-height-20 m-b-10">
        Al continuar aceptas los <a class="link-generic-style" target="_blank" [href]="url.documents.terminos">términos y condiciones</a>. Consulta nuestro <a class="link-generic-style" target="_blank" [href]="url.documents.aviso">aviso de privacidad.</a>         
       </p>
     </div>
     <div class="col-12  text-end mb-0">
       <div class="mb-0">
         <button class="button-generic-style button-blue height-48 width-247 width-md-172 width-xs-140" type="submit" [disabled]="form.invalid">Continuar</button>
       </div>
     </div>
   </form>
